import TransactionsPartDataItem from './transactions-page.part.data-item';
import TransactionsPartFilteredDataItem from './transactions-page.part.filtered-data-item';
import { ReactComponent as UserIcon } from '../../../assets/icons/user.svg';
import { ReactComponent as MerchantIcon } from '../../../assets/icons/merchant.svg';
import { ReactComponent as CardIcon } from '../../../assets/icons/processor-card.svg';
import { ReactComponent as RefreshIcon } from '../../../assets/icons/refresh.svg';
import { ReactComponent as PdfIcon } from '../../../assets/icons/pdf.svg';
import TableContent from '../../../components/table-content';
import { useEffect, useState, useCallback, useRef } from 'react';
import { apiService } from '../../../services/api.service';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppStore } from '../../../store/store';
import { UserState } from '../../../store/user.slice';
import TableFilters from '../../../components/table-filters';
import TimeFilters from '../../../components/time-filters';
import dateService from '../../../services/date.service';
import AppSelect from '../../../components/form/base/app-select';
import { StatusType } from '../../../types/statistics.types';
import { LabelValue } from '../../../types/label-value.types';
import Button from '../../../components/button';
import TablePagination from '../../../components/table-pagination';
import { errorService } from '../../../services/error.service';
import { generateOptions, TransactionSummary } from '../../../types/transaction.types';
import { formatAmount } from '../../../utils/number-utils';
import AppModalRefund from '../../../components/app-modal-refund-transaction';
import AppModalEditProcessorTransactionId from '../../../components/app-modal-edit-processor-transaction-id';
import { ReactComponent as EditIcon } from '../../../assets/icons/edit.svg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './transactions-page.scss';
import { useActiveMerchantFilters } from '../../../utils/use-active-merchant-filters';




interface Transaction {
    id: string;
    status: string;
    customerName: string;
    merchantName: string;
    processorName: string;
    processorTransactionId?: string;
    amount: number;
    allowedActions: string[];
    date: string;
}

const mockTransactionsLoading: Transaction[] = [
    {
        id: "TX1001",
        status: "APPROVED",
        customerName: "Alice Johnson",
        merchantName: "Amazon",
        processorName: "Stripe",
        amount: 129.99,
        allowedActions: ["REFUND"],
        date: "2025-06-16T10:12:00Z"
    },
    {
        id: "TX1002",
        status: "DECLINED",
        customerName: "Bob Smith",
        merchantName: "eBay",
        processorName: "PayPal",
        amount: 45.50,
        allowedActions: [],
        date: "2025-06-15T14:30:00Z"
    },
    {
        id: "TX1003",
        status: "PENDING",
        customerName: "Carol White",
        merchantName: "BestBuy",
        processorName: "Square",
        amount: 210.00,
        allowedActions: [],
        date: "2025-06-14T09:22:00Z"
    },
    {
        id: "TX1004",
        status: "REFUNDED",
        customerName: "David Brown",
        merchantName: "Target",
        processorName: "Adyen",
        amount: 89.00,
        allowedActions: [],
        date: "2025-06-13T16:45:00Z"
    },
    {
        id: "TX1005",
        status: "CHARGEBACK",
        customerName: "Eva Green",
        merchantName: "Walmart",
        processorName: "Stripe",
        amount: 300.00,
        allowedActions: [],
        date: "2025-06-12T12:00:00Z"
    },
    {
        id: "TX1006",
        status: "APPROVED",
        customerName: "Frank Taylor",
        merchantName: "Apple Store",
        processorName: "PayPal",
        amount: 999.99,
        allowedActions: ["REFUND"],
        date: "2025-06-11T08:15:00Z"
    },
    {
        id: "TX1007",
        status: "ERROR",
        customerName: "Grace Lee",
        merchantName: "Zalando",
        processorName: "Square",
        amount: 75.00,
        allowedActions: [],
        date: "2025-06-10T20:00:00Z"
    },
    {
        id: "TX1008",
        status: "RDR",
        customerName: "Henry Adams",
        merchantName: "AliExpress",
        processorName: "Adyen",
        amount: 60.25,
        allowedActions: [],
        date: "2025-06-09T07:30:00Z"
    },
    {
        id: "TX1009",
        status: "APPROVED",
        customerName: "Ivy Wilson",
        merchantName: "Shopify",
        processorName: "Stripe",
        amount: 150.49,
        allowedActions: ["REFUND"],
        date: "2025-06-08T11:10:00Z"
    },
    {
        id: "TX1010",
        status: "PENDING",
        customerName: "Jack Miller",
        merchantName: "Etsy",
        processorName: "PayPal",
        amount: 23.75,
        allowedActions: [],
        date: "2025-06-07T18:20:00Z"
    }
];


const TransactionsPage: React.FC = () => {

    const navigate = useNavigate();

    const [isModalVisible, setModalVisible] = useState(false);

    const [filters, setFilters] = useState({});

    const { effectiveFilters, canFetch } = useActiveMerchantFilters(filters);

    const [transactions, setTransactions] = useState<Transaction[]>();
    const [transactionsLoader, setTransactionsLoader] = useState(false);


    const [modalData, setModalData] = useState({
        id: '',
        status: '',
        newStatus: '',
    });

    const { user } = useSelector<AppStore, UserState>((state) => state.user)

    const [refreshingTransactionId, setRefreshingTransactionId] = useState<string | null>(null);

    const [resetTrigger, setResetTrigger] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [totalPages, setTotalPages] = useState(1)

    const [totalTransactions, setTotalTransactions] = useState();

    const [transactionStats, setTransactionStats] = useState({
        successTransactionsNo: 0,
        errorTransactionsNo: 0,
        successTransactionsAmount: 0,
        errorTransactionsAmount: 0,
        successTransactionsPercent: 0,
        errorTransactionsPercent: 0,
    });
    const [statsLoader, setStatsLoader] = useState(false);

    const [transactionsSummary, setTransactionsSummary] = useState<TransactionSummary>();
    const [summaryLoader, setSummaryLoader] = useState(false);

    const isMerchant = (user?.roles?.includes("merchant") || user?.roles?.includes("bas_merchant_view")) ?? false;
    const isAdmin = user?.roles?.includes("pg_admin") ?? false;

    const [refreshData, setRefreshData] = useState(false);

    const [isActionUsed, setIsActionUsed] = useState(false);

    const [isDesktop, setIsDesktop] = useState(false);

    const [refundId, setRefundId] = useState('');

    const [modalAction, setModalAction] = useState('');

    const [isEditProcessorIdModalVisible, setEditProcessorIdModalVisible] = useState(false);
    const [editProcessorIdData, setEditProcessorIdData] = useState({ id: '', processorTransactionId: '' });


    useEffect(() => {
        const checkScreenSize = () => {
            setIsDesktop(window.innerWidth > 1024);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => {
            window.removeEventListener('resize', checkScreenSize);
        };
    }, []);

    // Ref to track if a fetch is in progress to prevent duplicate calls
    const isFetchingRef = useRef(false);
    // Ref to store the last fetched filters/currentPage to avoid unnecessary refetches
    const lastFetchParamsRef = useRef<string>('');

    // Main effect: Fetch data when user, filters, or currentPage changes
    useEffect(() => {
        if (!canFetch) {
            return;
        }
        // Create a unique key for current fetch parameters to detect actual changes
        // Sort filter keys to ensure consistent stringification
        const normalizedFilters = Object.keys(effectiveFilters)
            .sort()
            .reduce((acc, key) => {
                const value = effectiveFilters[key as keyof typeof effectiveFilters];
                // Only include defined values to avoid undefined vs missing key differences
                if (value !== undefined && value !== null && value !== '') {
                    acc[key] = value;
                }
                return acc;
            }, {} as Record<string, any>);

        const fetchKey = JSON.stringify({
            userId: user?.id,
            filters: normalizedFilters,
            currentPage
        });

        // Skip if parameters haven't actually changed (even if same object reference)
        if (lastFetchParamsRef.current === fetchKey) {
            return;
        }

        // Update last fetch params immediately to prevent duplicate calls
        // This must happen before any async operations
        lastFetchParamsRef.current = fetchKey;

        // If already fetching, the cleanup will handle cancelling
        // Mark as fetching for this new request
        isFetchingRef.current = true;

        // Fetch statistics
        setStatsLoader(true);
        const statsPromise = apiService.getSuccessAndErrorStatistics(effectiveFilters)
            .then((response) => {
                // Only update if this fetch is still current (fetchKey hasn't changed)
                if (lastFetchParamsRef.current === fetchKey && response?.data) {
                    console.log('Setting transaction stats:', response.data);
                    setTransactionStats(response.data);
                } else {
                    console.log('Skipping stats update - fetchKey changed or no data', {
                        currentKey: lastFetchParamsRef.current,
                        expectedKey: fetchKey,
                        hasData: !!response?.data,
                        response: response
                    });
                }
            })
            .catch((e) => {
                if (lastFetchParamsRef.current === fetchKey) {
                    console.error('Error fetching statistics:', e);
                }
            })
            .finally(() => {
                // Always reset loading state to prevent stuck loading animations
                setStatsLoader(false);
            });

        // Fetch summary
        setSummaryLoader(true);
        const summaryPromise = apiService.getTransactionsSummary(effectiveFilters)
            .then((response) => {
                // Only update if this fetch is still current
                if (lastFetchParamsRef.current === fetchKey && response?.data) {
                    console.log('Setting transactions summary:', response.data);
                    setTransactionsSummary(response.data);
                } else {
                    console.log('Skipping summary update - fetchKey changed or no data', {
                        currentKey: lastFetchParamsRef.current,
                        expectedKey: fetchKey,
                        hasData: !!response?.data,
                        response: response
                    });
                }
            })
            .catch((error) => {
                if (lastFetchParamsRef.current === fetchKey) {
                    console.error('Error fetching transactions summary:', error);
                }
            })
            .finally(() => {
                // Always reset loading state to prevent stuck loading animations
                setSummaryLoader(false);
            });

        // Fetch transactions
        setTransactionsLoader(true);
        const pageInfo = {
            page: currentPage - 1,
            size: 10,
        };
        const transactionsPromise = apiService.getTransactions(effectiveFilters, pageInfo)
            .then((response) => {
                // Only update if this fetch is still current
                if (lastFetchParamsRef.current === fetchKey && response?.data) {
                    console.log('Setting transactions:', {
                        content: response.data.content?.length || 0,
                        totalPages: response.data.totalPages,
                        totalElements: response.data.totalElements,
                        fullResponse: response.data
                    });
                    setTransactions(response.data.content || []);
                    setTotalPages(response.data.totalPages || 1);
                    setTotalTransactions(response.data.totalElements || 0);
                } else {
                    console.log('Skipping transactions update - fetchKey changed or no data', {
                        currentKey: lastFetchParamsRef.current,
                        expectedKey: fetchKey,
                        hasData: !!response?.data,
                        response: response
                    });
                }
            })
            .catch((error) => {
                if (lastFetchParamsRef.current === fetchKey) {
                    console.error('Error fetching transactions:', error);
                    setTransactions([]);
                }
            })
            .finally(() => {
                // Always reset loading state to prevent stuck loading animations
                setTransactionsLoader(false);
            });

        // Reset fetching flag when all requests complete
        Promise.allSettled([statsPromise, summaryPromise, transactionsPromise])
            .finally(() => {
                // Always reset flag, even if cancelled
                isFetchingRef.current = false;
            });

        // Cleanup function: if dependencies change, update lastFetchParamsRef
        // This will cause old promises to skip state updates when they resolve
        return () => {
            // Reset fetching flag so new effect can proceed
            isFetchingRef.current = false;
            // Note: We don't need to set a cancellation flag because we check
            // lastFetchParamsRef.current === fetchKey in each promise handler
            // If a new fetch started, lastFetchParamsRef.current will be different
            // and the old promises will skip updating state
        };
    }, [user, effectiveFilters, currentPage, canFetch]);

    // Polling effect: Set up interval to refresh transactions only (not stats/summary)
    // This interval only runs every 60 seconds and doesn't execute immediately,
    // so it won't cause duplicate calls when dependencies change
    useEffect(() => {
        if (!canFetch) {
            return;
        }
        const intervalId = setInterval(() => {
            // Only refresh transactions list, not stats/summary (those update less frequently)
            // Skip if already fetching
            if (isFetchingRef.current) {
                return;
            }

            isFetchingRef.current = true;
            const pageInfo = {
                page: currentPage - 1,
                size: 10,
            };

            apiService.getTransactions(effectiveFilters, pageInfo)
                .then((response) => {
                    if (response?.data) {
                        setTransactions(response.data.content);
                        setTotalPages(response.data.totalPages);
                        setTotalTransactions(response.data.totalElements);
                    }
                })
                .catch((error) => {
                    setTransactions([]);
                })
                .finally(() => {
                    isFetchingRef.current = false;
                });
        }, 60000);

        return () => clearInterval(intervalId);
    }, [effectiveFilters, currentPage, canFetch]);

    const columnsMidTransactions = [
        {
            Header: 'Trace ID',
            accessor: 'id',
            Cell: ({ value }: { value: string }) => (
                <div>
                    <span
                        className="id-text"
                        onClick={() => {
                            const url = `/app/transactions/transaction/${value}`;
                            if (isDesktop) {
                                window.open(url, '_blank');
                            } else {
                                navigate(url);
                            }
                        }}
                    >{value}</span>
                </div>
            ),
        },
        {
            Header: 'Customer',
            accessor: 'customerName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <UserIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.customerCardType} xxxx xxxx xxxx {row.original.customerLastFourCardDigits}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Merchant',
            accessor: 'merchantName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <MerchantIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">{row.original.transactionReferenceCode}</div>
                </div>
            ),
        },
        {
            Header: 'Channel',
            accessor: 'processorName',
            Cell: ({ value, row }: { value: string; row: any }) => (

                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <CardIcon />
                        <span>{value}</span>
                    </div>
                    {!isMerchant &&
                        <div className="flex-row flex-gap-5 flex-align-start-center">
                            <span className="secondary-text accent-gradient-text">
                                {row.original.processorTransactionId}
                            </span>
                            {isAdmin &&
                                <EditIcon
                                    className="edit-processor-id-icon"
                                    onClick={() => {
                                        setEditProcessorIdData({
                                            id: row.original.id,
                                            processorTransactionId: row.original.processorTransactionId || '',
                                        });
                                        setEditProcessorIdModalVisible(true);
                                    }}
                                />
                            }
                        </div>
                    }
                </div>
            ),
        },
        {
            Header: 'Value',
            accessor: 'amount',
            Cell: ({ value }: { value: string }) =>
                <span className="value-text accent-gradient-text">${formatAmount(+value)}</span>
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Status
                </div>
            ),
            accessor: 'status',
            Cell: ({ value, row }: { value: string; row: any }) => {
                if (isMerchant) {
                    return (<div
                        className={`status ${value?.toLowerCase()}
                 flex-row flex-align-center-center`}
                        onClick={() => navigate(`/app/transactions/transaction/${row.original.id}`)}
                    >
                        <span>{value}</span>
                    </div>)
                }

                const { status, intermediateStatus } = row.original;

                const options: LabelValue<StatusType>[] = generateOptions(status, intermediateStatus);



                return (
                    <div className='flex-row flex-align-center-center width-100'>
                        {
                            options.length > 0 ? (
                                <AppSelect
                                    theme="status"
                                    options={options}
                                    placeholder={value}
                                    onChange={(newValue) => {
                                        setModalData({
                                            id: row.original.id,
                                            status: value,
                                            newStatus: newValue,
                                        });
                                        if (row.original.processorType === "WORLD_ACQUIRING") {
                                            setModalAction("UPDATE_STATUS")
                                        } else {
                                            setModalAction("")
                                        }
                                        setModalVisible(true);
                                    }}
                                />
                            ) : (
                                <div
                                    className={`status ${value?.toLowerCase()} flex-row flex-align-center-center`}
                                >
                                    <span
                                        onClick={() => {
                                            if (value === StatusType.ERROR)
                                                navigate(`/app/transactions/transaction/${row.original.id}`)
                                        }}
                                    >{value}</span>
                                </div>

                            )
                        }
                    </div>
                );
            },
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Time
                </div>
            ),
            accessor: 'date',
            Cell: ({ value }: { value: string }) =>
                <div className="date-text">{dateService.formatDateForTable(value)}</div>
        },
        {
            Header: () => (
                <div className="flex-row flex-align-center-center">
                    Log
                </div>
            ),
            accessor: "logs",
            Cell: ({ value, row }: { value: any; row: any }) =>
                row.original.status === StatusType.DECLINED &&
                    Array.isArray(value) &&
                    value.length > 0 &&
                    value[0]?.processorInternalStatus
                    ? <div className="date-text">{value[0]?.processorInternalStatus}</div>
                    : null
        },
        {
            Header: 'Actions',
            accessor: 'allowedActions',
            Cell: ({ value, row }: { value: string[]; row: any }) => {

                return (
                    <div className="flex-column flex-gap-5 flex-align-center-center">
                        {isAdmin && row.original.status === StatusType.APPROVED && row.original.processorType !== 'WORLD_ACQUIRING' &&
                            <div
                                className='action invoice'
                                onClick={() => handleDownloadInvoice(row.original.id)}
                            >
                                <span>INVOICE</span>
                            </div>
                        }
                        {(row.original.status !== StatusType.CHARGEBACK && row.original.status !== StatusType.REFUNDED && row.original.status !== StatusType.RDR) &&
                            <>
                                <RefreshIcon
                                    className={`refresh-icon ${refreshingTransactionId === row.original.id ? 'rotate' : ''
                                        }`}
                                    onClick={() => {
                                        if (refreshingTransactionId !== row.original.id)
                                            handleRefreshClick(row.original.id)
                                    }}

                                />
                                {row.original.status == StatusType.APPROVED &&
                                    <div
                                        className='action refund'
                                        onClick={() => {
                                            setIsActionUsed(true)
                                            setModalData({
                                                id: row.original.id,
                                                status: StatusType.APPROVED,
                                                newStatus: StatusType.REFUNDED,
                                            });
                                            setModalVisible(true);
                                            setModalAction('')
                                        }}>
                                        <span className='refunded'>REFUND</span>
                                    </div>
                                }
                            </>}
                    </div>
                )
            },
        },
    ];

    const handleTimeFilters = (startDate?: string, endDate?: string) => {
        setFilters((prev) => ({ ...prev, startDate, endDate }));
        setCurrentPage(1);
    };

    const handleTableFilters = (newFilters: Record<string, any>) => {
        setFilters((prev) => ({ ...prev, ...newFilters }));
        setCurrentPage(1);
    };

    const resetFilters = () => {
        setFilters({});
        setResetTrigger((prev) => !prev);
        setCurrentPage(1);
    };

    const handleRefreshClick = async (transactionId: string) => {
        setRefreshingTransactionId(transactionId);
        const startTime = Date.now();
        try {
            const response = await apiService.refreshTransaction(transactionId);
            const updatedStatus = response.data.status;

            setTransactions((prevTransactions) =>
                prevTransactions?.map((transaction) =>
                    transaction.id === transactionId
                        ? { ...transaction, status: updatedStatus }
                        : transaction
                )
            );
        } catch (e) {
            errorService.showApiError(e);
        } finally {
            const elapsedTime = Date.now() - startTime;
            const minimumDuration = 2000;

            const remainingTime = Math.max(0, minimumDuration - elapsedTime);

            setTimeout(() => {
                setRefreshingTransactionId(null);
                errorService.showSuccess('Success', 'Status has been updated');
            }, remainingTime);
        }
    };

    const handleDownloadInvoice = async (transactionId: string) => {
        try {
            const response = await apiService.downloadInvoice(transactionId);
            const contentDisposition = response.headers?.['content-disposition'];
            console.log(response)
            const filenameMatch = contentDisposition?.match(/filename="?([^";\n]+)"?/);
            const filename = filenameMatch?.[1] || `invoice-${transactionId}.pdf`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (e) {
            errorService.showApiError(e);
        }
    };

    const handleUpdateRefundId = (refundId: string) => {
        setRefundId(refundId)
    }

    const handleUpdateStatus = async (transactionId: string, newStatus: StatusType, refundId?: string) => {
        setRefreshingTransactionId(transactionId);
        const startTime = Date.now();
        try {
            if (!refundId) {
                const response = await apiService.updateTransactionStatus(transactionId, newStatus)
                const updatedStatus = response.data.status;
                setTransactions((prevTransactions) =>
                    prevTransactions?.map((transaction) =>
                        transaction.id === transactionId
                            ? { ...transaction, status: updatedStatus }
                            : transaction
                    )
                );
                errorService.showSuccess('Success', 'Status has been updated');
                setModalVisible(false);
            } else {
                const response = await apiService.updateTransactionStatusWithRefundId(transactionId, newStatus, refundId)
                const updatedStatus = response.data.status;
                setTransactions((prevTransactions) =>
                    prevTransactions?.map((transaction) =>
                        transaction.id === transactionId
                            ? { ...transaction, status: updatedStatus }
                            : transaction
                    )
                );

                errorService.showSuccess('Success', 'Status has been updated');
                setModalVisible(false);
                setRefundId("")
            }

        } catch (e) {
            errorService.showApiError(e);
            setModalVisible(false);
        } finally {
            const elapsedTime = Date.now() - startTime;
            const minimumDuration = 2000;

            const remainingTime = Math.max(0, minimumDuration - elapsedTime);
            setTimeout(() => {
                setRefreshingTransactionId(null);
            }, remainingTime);
        }
    };


    const handleRefundTransaction = async (transactionId: string) => {
        setModalVisible(false);
        try {
            const response = await apiService.refundTransaction(transactionId)
            if (response?.data?.success === true) {
                errorService.showSuccess('Refund Initiated', 'Refund request has been successfully submitted.');
                handleUpdateStatus(transactionId, StatusType.REFUNDED)
            } else {
                errorService.showError("Refund Failed", "Refund cannot be proccesed.");
            }

        } catch (e) {
            errorService.showApiError(e);
        } finally {
            setIsActionUsed(false);
        }
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const handleSaveProcessorTransactionId = async (transactionId: string, processorTransactionId: string) => {
        try {
            await apiService.updateProcessorTransactionId(transactionId, processorTransactionId);
            setTransactions((prevTransactions) =>
                prevTransactions?.map((transaction) =>
                    transaction.id === transactionId
                        ? { ...transaction, processorTransactionId }
                        : transaction
                )
            );
            errorService.showSuccess('Success', 'Processor Transaction ID has been updated');
            setEditProcessorIdModalVisible(false);
        } catch (e) {
            errorService.showApiError(e);
        }
    };

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };


    return (
        <div className="transactions-page page-content">

            <div className="page-header flex-row flex-gap-10 flex-align-start-center ">
                <div className='page-title'>
                    Transactions
                </div>

            </div>
            <div className='flex-row flex-gap-20 width-100 flex-wrap'>
                <TransactionsPartDataItem
                    theme='success'
                    total={transactionStats?.successTransactionsAmount}
                    noTransactions={transactionStats?.successTransactionsNo}
                    rate={transactionStats?.successTransactionsPercent}
                    isLoading={statsLoader}
                />
                <TransactionsPartDataItem
                    theme='error'
                    total={transactionStats?.errorTransactionsAmount}
                    noTransactions={transactionStats?.errorTransactionsNo}
                    rate={transactionStats?.errorTransactionsPercent}
                    isLoading={statsLoader}
                />
                <TransactionsPartFilteredDataItem
                    total={transactionsSummary?.totalAmount || 0}
                    noTransactions={transactionsSummary?.transactionCount || 0}
                    filters={filters}
                    dontShowPDF
                    isLoading={summaryLoader}
                    isAdmin={isAdmin}
                />
            </div>
            <TimeFilters
                handleFilters={handleTimeFilters}
                transactionsNo={totalTransactions}
                resetTrigger={resetTrigger} />
            <TableFilters
                onFiltersChange={handleTableFilters}
                resetTrigger={resetTrigger}
                showSearchByLogs
            />
            <Button theme='accent' label='Clear Filters' onClick={resetFilters} />
            <TablePagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
            <div className='inner-page flex-column flex-gap-30 width-100'>
                <TableContent columns={columnsMidTransactions} data={transactions || []} isLoading={transactionsLoader} />
            </div>
            <TablePagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
            <AppModalRefund
                text={`Are you sure you want to change the STATUS of the transaction to `}
                id={modalData.id}
                confirmLabel="Confirm"
                cancelLabel="Cancel"
                confirmAction={isActionUsed ? handleRefundTransaction : handleUpdateStatus}
                cancelAction={handleCancel}
                isVisible={isModalVisible}
                status={modalData.newStatus as StatusType}
                refundId={refundId}
                setRefundId={handleUpdateRefundId}
                action={modalAction}
            />
            <AppModalEditProcessorTransactionId
                isVisible={isEditProcessorIdModalVisible}
                transactionId={editProcessorIdData.id}
                currentValue={editProcessorIdData.processorTransactionId}
                confirmAction={handleSaveProcessorTransactionId}
                cancelAction={() => setEditProcessorIdModalVisible(false)}
            />
        </div>
    )
}

export default TransactionsPage